import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Make your things pretty with chroma-js",
  "description": "",
  "published": "2018-03-02T00:00:00.000Z",
  "redirect_from": ["/blog/make-things-pretty-chroma-js/swizec/8233"],
  "categories": "Front End, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/piechart-colored-with-chromajs.png",
        "alt": null
      }}></img></p>
    <p>{`I once asked `}<a parentName="p" {...{
        "href": "https://twitter.com/sxywu"
      }}>{`Shirley Wu`}</a>{` how she makes all her dataviz so pretty: Baskerville font and `}<a parentName="p" {...{
        "href": "https://github.com/gka/chroma.js"
      }}>{`chroma-js`}</a>{`.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Wow `}<a parentName="p" {...{
          "href": "https://twitter.com/sxywu"
        }}>{`@sxywu`}</a>{` was right, chroma.js really makes things pretty. `}<a parentName="p" {...{
          "href": "https://t.co/FWPhvmnGCR"
        }}>{`pic.twitter.com/FWPhvmnGCR`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/969128459011162112"
      }}>{`March 1, 2018`}</a></blockquote>
    <p>{`Chroma is a JavaScript library for dealing with colors. Read them, change them, make some delightful scales. It has changed the way I work.`}</p>
    <p>{`I'm still new to the library, so I don't know everything. Here are some useful things I've found.`}</p>
    <p>{`You can see them in action in `}<a parentName="p" {...{
        "href": "https://build-bwwgxbfasv.now.sh/"
      }}>{`this unfinished piechart`}</a>{` showing how I spend money on transport. More on that next week.`}</p>
    <h2 {...{
      "id": "delightful-color-scales"
    }}>{`Delightful color scales`}</h2>
    <p>{`Chroma color scales are designed to be delightful. You define two colors, and chroma-js finds the most pleasant path between them.`}</p>
    <p>{`See the Pen `}<a parentName="p" {...{
        "href": "https://codepen.io/swizec/pen/XZGvYe/"
      }}>{`Chroma basic scale`}</a>{` by Swizec Teller (`}<a parentName="p" {...{
        "href": "https://codepen.io/swizec"
      }}>{`@swizec`}</a>{`) on `}<a parentName="p" {...{
        "href": "https://codepen.io"
      }}>{`CodePen`}</a>{`.`}</p>
    <p>{`The quickest way to get some pretty colors going is to define an ordinal scale like this. Choose start and end points, say you want 6 colors, and pick the `}<inlineCode parentName="p">{`lch`}</inlineCode>{` mode.`}</p>
    <p>{`I'm not sure what `}<inlineCode parentName="p">{`lch`}</inlineCode>{` mode means, but it creates nicer colors than the default `}<inlineCode parentName="p">{`rgb`}</inlineCode>{` mode. They come out brighter.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/lch-vs-rgb.png",
        "alt": null
      }}></img></p>
    <p>{`You can create continuous scales as well. Add multiple points of reference etc. Great for encoding data with color.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/continuous-scales.png",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "prettier-hover-effects"
    }}>{`Prettier hover effects`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/hover-effect.gif",
        "alt": null
      }}></img></p>
    <p>{`Chroma also helps you create prettier hover effects. Color effects in general, really.`}</p>
    <p>{`You often see in web and dataviz design that people use opacity changes to create hover effects. You mouse over something and it becomes a little transparent so the white background shines through.`}</p>
    <p>{`This works, but looks bland. It lightens the color. What you want instead is to make the color look brighter.`}</p>
    <p>{`Chroma to the rescue with its color manipulation utilities.`}</p>
    <pre><code parentName="pre" {...{}}>{`chroma(color).brighten(2)
`}</code></pre>
    <p>{`You can also `}<inlineCode parentName="p">{`saturate`}</inlineCode>{`, `}<inlineCode parentName="p">{`desaturate`}</inlineCode>{`, and `}<inlineCode parentName="p">{`darken`}</inlineCode>{`. All useful effects if you find an excuse to use them. All better than just changing opacities.`}</p>
    <h2 {...{
      "id": "color-brewer"
    }}>{`Color brewer`}</h2>
    <p>{`If you're color challenged like me, then you can't go wrong with the `}<a parentName="p" {...{
        "href": "http://colorbrewer2.org/#type=sequential&scheme=BuGn&n=3"
      }}>{`color brewer utilities`}</a>{`. A set of predefined colors that look great together.`}</p>
    <p>{`That piechart above is made with the `}<inlineCode parentName="p">{`PuBu`}</inlineCode>{` schema. `}<inlineCode parentName="p">{`chroma.scale("PuBu")`}</inlineCode>{`. No need to worry too much, just go to `}<a parentName="p" {...{
        "href": "http://colorbrewer2.org/#type=sequential&scheme=BuGn&n=3"
      }}>{`color brewer`}</a>{`, find a scheme you like, and tell Chroma to use it.`}</p>
    <p>{`Happy coloring 🙏🏻`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      